/**
 * Resolve the public-facing display name for a user object.
 *
 * Mirror of the backend `services/user_display.effective_name`. Use this
 * everywhere the frontend renders a name that should respect the optional
 * `display_name` (nickname) field.
 *
 * Empty-safe — always returns a string (never null).
 */
export const effectiveName = (user) => {
  if (!user) return '';
  const nickname = (user.display_name || '').trim();
  if (nickname) return nickname;
  return (user.name || '').trim();
};

/** First-letter helper for avatar fallbacks. Returns 'U' when blank. */
export const nameInitial = (user) => {
  const n = effectiveName(user);
  return n ? n.charAt(0).toUpperCase() : 'U';
};
